import { map } from 'rxjs/operators';
import { IRole, IUser, User } from '@interfaces';
import { RoleService } from './../role/role.service';
import { Subscription } from 'rxjs';
import { Directive, OnInit, OnDestroy, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { AppService } from '@base/app.service';
import * as _ from 'lodash';

@Directive({
  selector: '[appAllowedRoles]'
})
export class AllowedRolesDirective implements OnInit, OnDestroy {
  @Input() appAllowedRoles: string[];
  isVisible = false;
  currentUser: IUser;
  subscription: Subscription;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private globalService: AppService,
  ) {
    this.currentUser = new User();
  }

  ngOnInit() {
    this.subscription = this.globalService.getCurrentUser().subscribe(
      res => {
        const emptyEmail = (this.currentUser.email.length < 1);

        if (!_.isEqual(this.currentUser, res)) {
          if (res.role !== null) {
            this.currentUser = res;
            this.setContainer();
          }
        }
      },
      err => {
        console.error(`Ocurrio un error: ${err.message}`);
      }
    );
  }

  // Clear the subscription on destroy
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setContainer() {
    let showElement = false;
    const roles: string[] = this.appAllowedRoles;

    if (roles.length === 1 && roles[0] === '*') {
      showElement = true;
    } else if (roles.length >= 1 && roles[0] !== '*') {
      const currentRole: IRole = this.currentUser.role;
      const objIndex = roles.findIndex((roleCode: string) => roleCode === currentRole.code);
      showElement = (objIndex >= 0);
    } else if (roles.length === 0) {
      showElement = false;
    }

    if (showElement) {
      if (!this.isVisible) {
        this.isVisible = true;
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else {
      this.isVisible = false;
      this.viewContainerRef.clear();
    }
  }
}
